import SearchIcon from './SearchIcon'

export default SearchIcon
